import * as Sentry from '@sentry/react';
import { AppEnvironment } from 'env';
import { debugLog } from './Logger';

export const TAG_COMPONENT = 'ComponentErrorHandler';
const TAG = 'LoggerCrash: ';

const logErrors = AppEnvironment.logErrors;

export interface ErrorType {
	error?: Error;
	message?: string;
	originalError?: Error;
}

export async function captureErrorLogs(error: ErrorType): Promise<void> {
	if (!logErrors) return;
	debugLog(TAG, 'logging error in sentry');
	try {
		const exception = (error.error ??
			error.message ??
			error.originalError) as Error;
		console.error(exception);
		Sentry.captureException(exception);
	} catch (e: unknown) {
		if (e instanceof Error) {
			debugLog(TAG, JSON.stringify(e));
		}
		Sentry.captureException(e);
	}
}

export async function captureComponentErrors(
	error: ErrorType,
	component: string,
) {
	if (!logErrors) return;
	debugLog(
		TAG,
		`logging error with tag ComponentErrorHandler:${component} in sentry`,
	);
	try {
		const exception = (error.error ??
			error.message ??
			error.originalError) as Error;
		Sentry.withScope((scope) => {
			scope.setTag('error_tag', `${TAG_COMPONENT}:${component}`);
			Sentry.captureException(exception);
		});
	} catch (e) {
		Sentry.captureException(e);
	}
}
